
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import screenpic1 from './bakeryscreen.png'
import screenpic12 from './wineryscreen.png'
import screenpic3 from './suitscreen.png'
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cards";

import "./styles.css";

// import required modules
import { EffectCards } from "swiper";
import { Paper } from '@mui/material';

export default function Cards() {
  return (
    <>
      <Swiper
        effect={"cards"}
        grabCursor={true}
        modules={[EffectCards]}
        className="mySwiper"
      >
        
        <SwiperSlide>
        <Paper sx={{width:'800px',heigh:'auto'}} >
      <img  width={'100%'} height={'100%'}    src={screenpic1} alt={''}  />
    </Paper>
    </SwiperSlide>
    <SwiperSlide>
        <Paper sx={{width:'800px',heigh:'auto'}}>
      <img width={'100%'} height={'100%'}   src={screenpic12} alt={''}  />
    </Paper>
    </SwiperSlide>
    <SwiperSlide>
        <Paper sx={{width:'900px',heigh:'auto'}}>
      <img  width={'84%'} height={'100%'}  src={screenpic3} alt={''}  />
    </Paper>
    </SwiperSlide>
        
       
        
      </Swiper>
    </>
  );
}
